var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sepTop"},_vm._l((_vm.items),function(item){return _c('div',{key:item.id},[_c('gold-record-item',{attrs:{"item":item}})],1)}),0),(_vm.items.length === 0)?_c('van-empty',{staticClass:"custom-image",attrs:{"image":require('@/static/ic_charge_empty.png'),"description":"暂无明细，赶快去充值一次吧"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }